import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import StaticMapDialog from '../../../components/Dialog/StaticMapDialog';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';

class OrderSummary01Route extends React.Component {
  static propTypes = {
    orderDetailInfo: PropTypes.shape().isRequired,
    // passengerCount: PropTypes.number.isRequired,
    // pickupTime: PropTypes.instanceOf(Date).isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      location: {},
      openStaticMap: false,
    };
    this.onClickShowStaticMap = this.onClickShowStaticMap.bind(this);
  }

  onClickShowStaticMap() {
    this.setState({ openStaticMap: !this.state.openStaticMap });
  }

  render() {
    return (
      <div className={s2.summaryLocation}>
        <p className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_summary_route_title}
        </p>
        <hr className={s2.hrBottom} />
        <dl className={s.address}>
          {this.props.orderDetailInfo.waypoints_attributes.map((i, index) => (
            <div key={index.toString()}>
              <span
                className={`${s2.rightText} ${s.hideMobile}`}
                role="button"
                tabIndex={0}
                onKeyPress={() => {}}
                onClick={() => {
                  this.setState({ location: { lat: i.lat, lon: i.lon } });
                  this.onClickShowStaticMap();
                }}
              >
                {
                  this.props.modelDataText
                    .order_summary_route_view_on_map_button
                }
              </span>
              <span
                className={`${s2.rightText} ${s.showMobile}`}
                role="button"
                tabIndex={0}
                onKeyPress={() => {}}
                onClick={() => {
                  this.setState({ location: { lat: i.lat, lon: i.lon } });
                  this.onClickShowStaticMap();
                }}
              >
                {
                  this.props.modelDataText
                    .order_summary_route_view_on_map_button_mobile
                }
              </span>
              <dd style={{ whiteSpace: 'nowrap' }}>
                {typeof i.detail_address !== 'undefined'
                  ? `${i.detail_address}, ${i.address}`
                  : i.address.toString()}
              </dd>
            </div>
          ))}
        </dl>
        <StaticMapDialog
          location={this.state.location}
          onClickShow={this.onClickShowStaticMap}
          modal={this.state.openStaticMap}
        />
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(OrderSummary01Route),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary01Route/OrderSummary01Route.js